import { useMemo } from 'react';
import humanizeDuration, { HumanizerOptions } from 'humanize-duration';
import { useTranslation } from 'react-i18next';

import { languages } from '~/features/internationalization/languages';

export function useHumanizeDuration(duration: number | null, options?: HumanizerOptions) {
  const { i18n } = useTranslation();

  const displayDuration = useMemo(() => {
    if (!duration) return null;

    let language = i18n.language;

    // Override language codes to match humanize-duration supported languages
    if (language === languages.enUS.preferenceCode) {
      language = 'en';
    }

    if (language === languages.frCA.preferenceCode) {
      language = 'fr';
    }

    return humanizeDuration(duration, {
      language,
      fallbacks: ['en'],
      largest: 1,
      units: ['mo', 'w', 'd', 'h', 'm'],
      round: true,
      ...options,
    });
  }, [duration, i18n, options]);

  return displayDuration;
}

export const RAW_DURATION_OPTIONS: HumanizerOptions = {
  largest: 1,
  units: ['h', 'm'],
  round: true,
};
